import { Record, List } from 'immutable';
import { actionTypes } from './accessibility-notifications.actions';
const uuid = require('uuid');


export const Notification = Record({
  id : '',
  message : '',
  alertLevel : '',
});

export const NotificationState = Record({
  notifications : List([])
});

export const accessibilityNotificationReducer = (state = new NotificationState(), action) => {

  switch (action.type) {
    case actionTypes.ADD:
    {
      const currentNotifications = state.get('notifications');
      return state.set('notifications', currentNotifications.push(new Notification({
        id : uuid(),
        message : action.message,
        alertLevel : action.alertLevel
      })));
    }
    case actionTypes.REMOVE:
    {
      const currentNotifications = state.get('notifications');
      return state.set('notifications', currentNotifications.filter(val => val.id !== action.id));
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/common/accessibility-notifications/accessibility-notifications.reducer.js